import React from "react";
import EditableTableComponent from "../../../Components/Table/EditableTable";

const Support = () => {
  const columns = [
    { header: "Add Text", accessor: "no", width: "50px" },
    { header: "Add Text", accessor: "support", align: "left", width: "235px" },
    {
      header: "Add Text",
      accessor: "responsibility",
      align: "left",
      width: "50px",
    },
  ];

  const initialData = [
    { no: "Add Text ", support: "Add Text", responsibility: "Add Text" },
  ];

  return (
    <div>
      <EditableTableComponent
        columns={columns}
        initialData={initialData}
        heading={"Support Required"}
      />
    </div>
  );
};

export default Support;
